import { z } from 'zod';

export const userSchema = z.object({
    isLoggedIn: z.boolean(),
    userName: z.string(),
});